export default __webpack_public_path__ + "static/media/sports07.9bd96a69.jpg";